module.exports = __webpack_public_path__ + "static/img/j-1.1362e69b.png";